import uniqid from 'uniqid'

/**
 * The shapes a new KPI module and its parts start life as.
 *
 * Kept in one place because three callers create them — the report editor's
 * module picker, and the outline's "add measure" and "add row" buttons — and a
 * row that starts with the wrong keys silently fails to inherit.
 */

export const DEFAULT_KPI_MODULE_STYLE = {
  type: 'KpiModuleStyle',
  columns_per_row: 4,
  card_width: 160,
  card_gutter: 8,
  show_card_background: true,
  card_background_color: 'ui-08',
  null_placeholder: '\u2014',
  null_placeholder_color: 'ui-04',
  space_before: 16,
  space_after: 32,
  add_divider: false,
  divider_color: null,
}

export function newKpiMeasure () {
  return {
    type: 'KpiMeasure',
    key: uniqid(),
    name: '',
    measure_config: { measure: null, },
    // Off by default: a module's headline is set deliberately, and a new
    // measure added to an existing module must not silently take the slot
    // from the one already in it.
    is_hero: false,
    // Which way is good, and whether a change reads as money or a percentage.
    // Both start unset so a new measure behaves exactly as one saved before
    // these settings existed; the editor prompts for them.
    good_direction: null,
    difference_type: null,
    data_format: {
      data_type: 'money',
      show_commas: true,
      decimal_places: 0,
      parenthesize_negatives: false,
      mm_ss: false,
      show_duration_label: false,
    },
  }
}

// Every field a row can inherit starts null, so a fresh row is "the same as
// the KPI it lands on" until something is changed.
export function newKpiRow () {
  return {
    type: 'KpiRow',
    key: uniqid(),
    name: '',
    measure_config: null,
    comparison_config: null,
    data_format: null,
    invert_direction: false,
  }
}

// Every field a benchmark can inherit starts null, so a fresh one is "the same
// as the KPI it lands on" until something is changed. `measure` for the
// difference type means each measure decides whether its change reads as money
// or as a percentage.
export function newKpiBenchmark () {
  return {
    type: 'KpiBenchmark',
    key: uniqid(),
    name: '',
    measure_config: null,
    show: 'both',
    difference_type: 'measure',
    conditional_format: null,
    data_format: null,
    invert_direction: false,
  }
}

export function newKpiModule () {
  return {
    key: uniqid(),
    title: 'KPIs',
    type: 'KpiModule',
    kpi_style: { ...DEFAULT_KPI_MODULE_STYLE, },
    kpi_measures: [],
    primary_row: newKpiRow(),
    benchmarks: [],
    filters: [],
  }
}
